module.exports = "<!--月选择-->\n<input month-range-picker start-date-range=\"startMonthRange1\" end-date-range=\"endMonthRange2\" event-change=\"\">\n";